import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { IFormInitialValue } from './types'

const initialState: IFormInitialValue = {
  first_name: '',
  last_name: '',
  middle_name: '',
  phone: '',
  emergency_contacts: '',
  date_of_birth: '',
  marital_status: '',
  address: '',
  email: '',
  gender: '',
  photo: '',
  photo_url: '',
  religion: '',
  username: '',
  role_id: '',
  password: '',
  password_confirmation: '',
  bank_name: "",
  bank_account_number: ""
}

export const PersonalSlice = createSlice({
  name: 'Personal',
  initialState,
  reducers: {
    addPersonal: (_state, action: PayloadAction<IFormInitialValue>) => action.payload,
  },
})

export const { addPersonal } = PersonalSlice.actions
export default PersonalSlice.reducer
